export default "<div class=\"ccc-loader\"></div>";